module.exports = __webpack_public_path__ + "img/Reporting-icon.e13a5927.svg";